/** Supported EVM chain keys (matches backend `tokencatalog` + i18n `wallet.chain.*`). */
export const SUPPORTED_EVM_CHAINS = [
  'ethereum',
  'sepolia',
  'bsc',
  'base',
  'avax',
  'polygon',
  'arb',
  'op',
] as const;

export type SupportedEvmChain = (typeof SUPPORTED_EVM_CHAINS)[number];

/** Chain IDs for client-only ops (e.g. EIP-7702 `authorize` without a provider). */
export const CHAIN_ID_BY_KEY: Record<string, bigint> = {
  ethereum: 1n,
  sepolia: 11155111n,
  bsc: 56n,
  base: 8453n,
  avax: 43114n,
  polygon: 137n,
  arb: 42161n,
  op: 10n,
};
